<div class="validation-display validation-display-hints" [ngClass]="classes" *ngIf="ctrl">
    <bk-validation-display-hints-element *ngFor="let item of itemsArray" [item]="item"></bk-validation-display-hints-element>
</div>
<div *ngIf="missingCtrl">bkFormControl?</div>